






























































































































































































import menuButton from "@/components/menuButton.vue";
import GlossaryPopUp from "@/components/GlossaryPopUp.vue";
import ReferencesPopUp from "@/components/ReferencesPopUp.vue";
import AbbrevsPopUp from "@/components/AbbrevsPopUp.vue";
export default {
  name: "drug1_tc",
  components: {
    menuButton,
    GlossaryPopUp,
    ReferencesPopUp,
    AbbrevsPopUp
  },
  mounted() {
    this.$on('click-refs', function() {
      this.$refs.refpop.showRefs();
    })
    this.$on('click-gloss', function() {
      this.$refs.glosspop.showGloss();
    })
    this.$on('click-abbrevs', function() {
      this.$refs.abbrevpop.showAbbrevs();
    })
    const pageName = this.$options.name;
    const pageRefs = this.$root.getPageReferences();
    console.log('refs = ' + pageRefs[pageName]);
    if (typeof pageRefs[pageName] != 'undefined') {
      this.$refs.refpop.setVisibleRefs(pageRefs[pageName]);
    }
  }
};
